import React from "react";
import { Paper, Typography, Box, Button } from "@mui/material";
import { GradientBorderAutocomplete } from "../../../components/common/GradientBorderAutocomplete";

interface ExportFilterBarProps {
  format: string;
  propertyFilter: string;
  roomFilter: string;
  lesseeFilter: string;
  propertyOptions: string[];
  roomOptions: string[];
  lesseeOptions: string[];
  onPropertyChange: (value: string) => void;
  onRoomChange: (value: string) => void;
  onLesseeChange: (value: string) => void;
  onSearch: () => void;
  onClearSearch: () => void;
  loading: boolean;
  mode: 'browse' | 'search';
  dataMode: 'full' | 'paginated' | null;
}

export const ExportFilterBar: React.FC<ExportFilterBarProps> = ({
  format,
  propertyFilter,
  roomFilter,
  lesseeFilter,
  propertyOptions,
  roomOptions,
  lesseeOptions,
  onPropertyChange,
  onRoomChange,
  onLesseeChange,
  onSearch,
  onClearSearch,
  loading,
  mode,
  dataMode,
}) => {
  if (format !== 'itandi') return null;

  return (
    <Paper sx={{ p: 2, mb: -1, flexShrink: 0, backgroundColor: "transparent", boxShadow: "none" }}>
      <Typography variant="h6" gutterBottom>
        <span style={{ color: "rgb(50, 225, 170)", fontWeight: "bold", fontSize: "1.5rem" }}>
          ステップ2
        </span>
        <span style={{ color: "black", fontWeight: "500", fontSize: "1.4rem" }}>
          : 対象レコードでしぼる
        </span>
      </Typography>
      <Box sx={{ display: "flex", gap: 2, alignItems: "center", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center" }}>
          <GradientBorderAutocomplete
            options={propertyOptions}
            inputValue={propertyFilter}
            onInputChange={(event, newInputValue) => onPropertyChange(newInputValue)}
            label="物件名"
            width={220}
          />
          <GradientBorderAutocomplete
            options={roomOptions}
            inputValue={roomFilter}
            onInputChange={(event, newInputValue) => onRoomChange(newInputValue)}
            label="部屋名"
            width={220}
          />
          <GradientBorderAutocomplete
            options={lesseeOptions}
            inputValue={lesseeFilter}
            onInputChange={(event, newInputValue) => onLesseeChange(newInputValue)}
            label="入居者名"
            width={220}
          />
        </Box>
        {(mode === 'search' || dataMode === 'paginated') && (
          <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
            <Button
              variant="contained"
              onClick={onSearch}
              disabled={loading}
              sx={{ minWidth: '80px', height: '40px' }}
            >
              検索
            </Button>
            <Button
              variant="outlined"
              onClick={onClearSearch}
              disabled={loading}
              sx={{ minWidth: '80px', height: '40px' }}
            >
              クリア
            </Button>
          </Box>
        )}
      </Box>
    </Paper>
  );
};
